export default __webpack_public_path__ + "static/media/eligibility.fb4804c6.svg";